import IsoLogoPink from '@/shared/assets/isotipo-cft-maule-pink.png';

/**
 * Componente de carga de página completa
 * Muestra una pantalla de carga con el isotipo institucional animado
 * Cubre toda la pantalla durante transiciones de navegación o carga de datos
 *
 * Características:
 * - Overlay de pantalla completa con gradiente púrpura
 * - Logo institucional con animación de pulso y escala
 * - Z-index elevado (z-50) para estar sobre todo el contenido
 * - Posicionamiento fijo para cubrir toda la ventana
 *
 * Uso: Se muestra durante transiciones en PrivateLayout cuando navigation.state === 'loading'
 */
const LoaderPage = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-purple-200 via-purple-100 to-white z-50">
      <img
        src={IsoLogoPink}
        alt="CFT Maule Logo"
        className="w-32 h-32 animate-pulse-scale-opacity"
      />
    </div>
  );
};

export default LoaderPage;
